
import UiButton from "@/components/UI/UiButton.vue";
import UiInputWrapper from "@/components/UI/UiInputWrapper.vue";
import UiInput from "@/components/UI/UiInput.vue";
import UiTextArea from "@/components/UI/UiTextArea.vue";
export default {
  components: {
    UiButton,
    UiInputWrapper,
    UiInput,
    UiTextArea,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      baseForm: {
        subject: "",
        question: "",
        name: "",
        email: "",
      },
      form: {
        subject: "",
        question: "",
        name: "",
        email: "",
      },
    };
  },
  methods: {
    async onSubmit() {
      try {
        const { data } = await this.$api.public.createProductQuestion({
          ...this.form,
          slug: process.env.DOMAIN + this.$route.fullPath,
        });
        this.$alert({
          title: this.$t("yourMessageIsSent"),
          text: this.$t("weWillGetBackToYouWithAnAnswerAsSoonAsPossible"),
        });
        this.form = JSON.parse(JSON.stringify(this.baseForm));
        this.$refs.questionForm?.reset();
      } catch (err) {
        console.log("err - ", err);
        const error = err?.response?.data?.errors?.[0];
        if (error?.property && error?.message) {
          this.$refs?.questionForm?.setErrors({
            [error.property]: error.message,
          });
        }
      }
    },
  },
};
